import { useState, useEffect } from "react";
import * as yup from "yup";
import { multiSelectSchema } from "utils/schemas";
import { asdmCourseReportConfig, asdmPhaseDateRanges } from "api/Consts";

function ASDMStatsFormBuilder(values) {
  const [schema, setSchema] = useState();

  useEffect(() => {
    const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    };
    const parseDate = (iso) => new Date(`${iso}T00:00:00`);
    const defaultStartDate = "2025-06-01";
    const defaultEndDate = (() => {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      return formatDate(d);
    })();

    const asdmProjectId = asdmCourseReportConfig.asdmProjectId ?? {};
    const phaseDateRanges = Object.entries(asdmPhaseDateRanges).reduce(
      (acc, [phase, range]) => {
        acc[phase] = {
          start: range.start,
          end: range.end || defaultEndDate,
        };
        return acc;
      },
      {},
    );

    const phaseOptions = Object.entries(asdmProjectId).map(
      ([phase, projectId]) => ({
        label: phase.replace("phase", "Phase "),
        value: projectId,
      }),
    );

    const projectIdToRange = Object.entries(asdmProjectId).reduce(
      (acc, [phase, projectId]) => {
        const range = phaseDateRanges[phase];
        if (range) acc[projectId] = range;
        return acc;
      },
      {},
    );

    const selectedProjectIds = Array.isArray(values?.project_id)
      ? values.project_id
      : values?.project_id
        ? [values.project_id]
        : [];

    let startValue = values?.start_date || defaultStartDate;
    let endValue = values?.end_date || defaultEndDate;

    if (selectedProjectIds.length && (!values?.start_date || !values?.end_date)) {
      const ranges = selectedProjectIds
        .map((id) => projectIdToRange[id])
        .filter(Boolean);
      if (ranges.length) {
        const minStart = ranges
          .map((r) => parseDate(r.start))
          .sort((a, b) => a - b)[0];
        const maxEnd = ranges
          .map((r) => parseDate(r.end))
          .sort((a, b) => b - a)[0];
        if (!values?.start_date) startValue = formatDate(minStart);
        if (!values?.end_date) endValue = formatDate(maxEnd);
      }
    }

    const schema = {
      start_date: {
        label: "Start Date",
        type: "date",
        defaultValue: startValue || defaultStartDate,
        value: startValue,
        schema: yup.string(),
      },
      end_date: {
        label: "End Date",
        type: "date",
        defaultValue: endValue || defaultEndDate,
        value: endValue,
        schema: yup.string(),
      },
      project_id: {
        type: "multi-select",
        required: true,
        label: "Select Phase",
        options: phaseOptions,
        schema: multiSelectSchema.min(1, "Phase is required"),
      },
    };
    setSchema(schema);
  }, [values]);

  return schema;
}

export default ASDMStatsFormBuilder;
